import useApi from "../../../../Utils/BackendClient";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { convertSumWithLatestCurrencyRate, formatCurrency, formatQuantityWithMeasurement, systemCurrenciesDropdown, useEnumLabel } from "../../../../Utils/Utils";
import StickerPrintSidebar from "../../../UIElements/StickerPrintSidebar";

import { Button } from "primereact/button";
import { Chip } from "primereact/chip";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner"
import { Sidebar } from "primereact/sidebar";
import { SplitButton } from "primereact/splitbutton";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Tree } from "primereact/tree";

import commonStyle from "../../CommonStyles.module.css";
import InputTextTemplate from "../../../UIElements/FilterTemplates/InputTextTemplate";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import DropDownTemplate from "../../../UIElements/FilterTemplates/DropDownTemplate";
import EnumsContext from "../../../../context/enums-context";
import useGetEnums from "../../../../Utils/EnumsUtils";
import TextInput from "../../../UIElements/Inputs/TextInput";
import CheckboxInput from "../../../UIElements/Inputs/CheckboxInput";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import NumberInput from "../../../UIElements/Inputs/NumberInput";


const LeftOvers = ({ isDarkTheme }) => {

    const buttonRef = useRef(null);
    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const toast = useRef(null);
    const { fetchProductsExtended, fetchPurchases, fetchRemainingQRCode, fetchRemainings, updateProductPrice, } = useApi();

    const [changePriceSiderBarVisible, setChangePriceSiderBarVisible] = useState(false);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: null,
        sortOrder: null,
        filters: {
            product_group: { value: null, matchMode: 'equals', name: '' },
            product_name: { value: "", matchMode: 'equals' },
            division_name: { value: null, matchMode: 'equals' },
            brand_name: { value: null, matchMode: 'equals' }
        }
    });
    const [leftovers, setLeftOvers] = useState(null);
    const [loading, setLoading] = useState(true);
    const [productCategoriesLoading, setProductCategoriesLoading] = useState(true);
    const [productHierarcy, setProductHierarchy] = useState([]);
    const [productGroupSidebarVisible, setProductGroupSidebarVisible] = useState(false);
    const [purchasedSidebarVisible, setPurchasedSidebarVisible] = useState(false);
    const [purchases, setPurchases] = useState(null);
    const [reloadData, setReloadData] = useState(false);
    const [saleItem, setSaleItem] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [changePriceProduct, setChangePriceProduct] = useState({
            remaining_id: "",
            accounting_type: "",
            product_name: "",
            use_product_sale_price: "",
            custom_sale_price_currency: "",
            custom_sale_price: "",
    })
    const [stickerSideBarVisible, setStickerSidebarVisible] = useState(false);
    const [tableFilters, setTableFilters] = useState({
        product_group: { value: null, matchMode: 'equals', name: '' },
        product_name: { value: "", matchMode: 'equals' },
        division_name: { value: null, matchMode: 'equals' },
        brand_name: { value: null, matchMode: 'equals' }
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [visible, setVisible] = useState(false);

    const enumTypes = useMemo(() => ["divisions", "brands_dictionary"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);
    const getBrandsLabel = useEnumLabel(ctx.enums.brands_dictionary.data);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetchProductsExtended();

            if (response.status !== 200) return;

            const buildHierarchy = (groups) => {
                return groups
                    .filter(group => group.is_active)
                    .map(group => {
                        const groupBlock = {
                            key: group.id,
                            label: group.group_name,
                            droppable: false,
                            children: group.sub_groups.length > 0 ? buildHierarchy(group.sub_groups) : undefined,
                        };

                        return groupBlock;
                    });
            };

            const hierarchy = buildHierarchy(response.data || []);
            console.log(hierarchy);

            setProductHierarchy(hierarchy);
            setProductCategoriesLoading(false);
        };

        fetchData();
    }, [fetchProductsExtended]);

    useEffect(() => {

        const fetchData = async () => {

            const response = await fetchRemainings(lazyState);

            if (response.status === 200) {
                setTotalRecords(response.data.count);
                setLeftOvers(response.data.results);
                setLoading(false);
            }
        }

        fetchData();
    }, [lazyState, fetchRemainings, reloadData]);

    const sideBarFormik = useFormik({
        initialValues: saleItem,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.quantity === null || values.quantity === undefined || values.quantity === "") {
                errors.quantity = "Введіть кількість";
            }

            return errors;
        },
        onSubmit: (values) => {
            setVisible(false);
            createNewSale(values);
        }
    });

    const changePriceFormik = useFormik({
        initialValues: changePriceProduct,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if(!values.use_product_sale_price)
            {
                if(!values.custom_sale_price_currency)
                {
                    errors.custom_sale_price_currency = "Валюта продажу не повинна бути пустою";
                }

                if(!values.custom_sale_price)
                {
                    errors.custom_sale_price = "Ціна продажу не повинна бути пустою";
                }
                else if(+values.custom_sale_price <= 0)
                {
                    errors.custom_sale_price = "Ціна продажу повинна більшою від нуля";
                }
            }

            return errors
        },
        onSubmit: async (values) => {

            const response = await updateProductPrice(values);

            if (response.status !== 200) {
                toast.current.show({ severity: "error", summary: "Помилка зміна ціни товару", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            else {
                toast.current.show({ severity: "success", summary: 'Зміна ціни', detail: 'Ціна товару успішно змінена', life: 3000 });
            }

            setChangePriceSiderBarVisible(false);
            setReloadData(!reloadData);
        }
    });

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
    };

    const onSort = (event) => {
        event.page = lazyState.page;
        setlazyState(event);
    }

    const onFilter = (event) => {
        event.page = 1;
        setTableFilters(event.filters);
    }

    const applyFilterFromMenu = (node) => {

        const filters = tableFilters;

        filters.product_group.value = node.key;
        filters.product_group.name = node.label;
        setTableFilters(filters);


        const state = lazyState;
        state.page = 1;
        state.first = 0;
        if (state.filters.product_group) {
            state.filters.product_group.value = node.key;
            state.filters.product_group.name = node.label;
        }
        else {
            state.filters.product_group = { value: node.key, matchMode: 'equals', name: node.label };
        }

        setlazyState(state);

        setProductGroupSidebarVisible(false);

        setReloadData(!reloadData);
    }

    const filterApply = () => {
        const editedLazyState = lazyState;
        editedLazyState.filters = tableFilters;
        editedLazyState.page = 1;
        editedLazyState.first = 0;
        setlazyState(editedLazyState);
        setReloadData(!reloadData)
    }

    const clearFilter = (paramName, value) => {
        setlazyState(prevState => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                [paramName]: {
                    ...prevState.filters[paramName],
                    value: value
                }
            }
        }));
    }

    const handleMobileFilterChange = (key, value) => {
        setTableFilters((prevFilters) => ({
            ...prevFilters,
            [key]: { ...prevFilters[key], value: value }
        }));
    }

    const clearMobileFilters = () => {
        setTableFilters({
            product_group: { value: null, matchMode: 'equals', name: '' },
            product_name: { value: "", matchMode: 'equals' },
            division_name: { value: null, matchMode: 'equals' }
        });

        setlazyState(prevState => ({
            ...prevState,
            filters: {
                product_group: { value: null, matchMode: 'equals', name: '' },
                product_name: { value: "", matchMode: 'equals' },
                division_name: { value: null, matchMode: 'equals' }
            }
        }));
    }

    const changePriceButtonHandler = rowData => {

        setChangePriceProduct({
            remaining_id: rowData.id,
            product_name: rowData.product_name,
            accounting_type: rowData.identifier === undefined ? "PIECE" : "INDIVIDUAL",
            use_product_sale_price: rowData.use_product_sale_price,
            custom_sale_price_currency: rowData.sale_price_currency,
            custom_sale_price: rowData.sale_price
        });

        setChangePriceSiderBarVisible(true);
    }

    const printPriceTag = async products => {

        let request = [];
        products.forEach(product => {
            const element = {
                remaining_id: product.id,
                accounting_type: product.identifier === undefined ? "PIECE" : "INDIVIDUAL"
            }
            request.push(element);
        });

        const response = await fetchRemainingQRCode(request);
        if (response.status === 200) {
            console.log(response);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;

            // Set a filename
            link.download = `QR_codes.pdf`; // Change based on your needs
            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);

            setSelectedProducts(null);
        }
        else {
            toast.current.show({ severity: 'error', summary: 'Помилка завантаження', detail: 'Помилка завантадення цінника', life: 3000 });
        }
    }

    const getPurchases = async rowData => {
        const request = {
            remaining_id: rowData.id,
            product_accounting_type: rowData.identifier !== undefined ? "INDIVIDUAL" : "PIECE"
        }

        const response = await fetchPurchases(request);

        if (response.status === 200) {
            setPurchases(response.data.results);
            setPurchasedSidebarVisible(true);
        }
        else {
            toast.current.show({ severity: 'error', summary: 'Помилка', detail: 'Помилка отримання списку покупок', life: 3000 });
            setPurchases([]);
        }
    }

    const clearFilterFromChips = (paramName, value) => {
        clearFilter(paramName, value);
        setTableFilters(prevState => ({
            ...prevState,
            [paramName]: {
                value: value
            }
        }));
    }

    const formatFilterChips = () => {
        const element = [];

        Object.keys(lazyState.filters).forEach((filterKey) => {
            const filter = lazyState.filters[filterKey];

            if (filter.value && filter.value !== "") {

                let translatedKey = filterKey;
                let changedValue = filter.value;
                let removeValue = null;


                if (filterKey === "product_group") {
                    translatedKey = "Назва групи";
                    changedValue = filter.name;
                }
                else if (filterKey === "product_name") {
                    translatedKey = "Назва товару";
                    removeValue = "";
                }
                else if (filterKey === "division_name") {
                    translatedKey = "Точка продажу";
                    changedValue = getDivisionLabel(changedValue);
                }
                else if(filterKey === "brand_name") {
                    translatedKey = "Бренд";
                    changedValue = getBrandsLabel(changedValue);
                }
                
                console.log(changedValue);

                element.push(
                    <Chip
                        key={filterKey}
                        label={`${translatedKey}: ${changedValue}`}
                        removable
                        onRemove={() => clearFilterFromChips(filterKey, removeValue)} // Optional: To handle removal
                    />
                );
            }
        });

        return <div className="flex flex-wrap gap-2">{element}</div>;
    }

    const toolbarLeftTemplate = () => {
        return (<div className="flex flex-column gap-2">
            <div className="flex gap-2">
                <Button
                    icon="pi pi-filter"
                    severity="secondary"
                    outlined={!showFilters}
                    onClick={() => setShowFilters(!showFilters)}
                />
                <Button
                    icon="pi pi-sitemap"
                    severity="secondary"
                    outlined
                    onClick={() => setProductGroupSidebarVisible(true)}
                />
                <Button
                    icon="pi pi-filter-slash"
                    severity="secondary"
                    outlined
                    onClick={() => clearMobileFilters()}
                />
            </div>
        </div>)
    }

    const header = (
        <div className="flex flex-wrap align-items-center">
            <div className="flex align-items-center justify-content-start gap-2">
                {formatFilterChips()}
            </div>
            {(selectedProducts && selectedProducts.length > 0) && <Button
                className={commonStyle.warningTag}
                severity="warning"
                label="Друкувати стікери"
                tooltipOptions={{ position: "top" }}
                onClick={() => setStickerSidebarVisible(true)}
            />}
        </div>
    );

    const mobileTableHeader = () => {
        return (
            showFilters && <div className="grid">
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <InputText
                            value={tableFilters.product_name.value}
                            onChange={(e) =>
                                handleMobileFilterChange("product_name", e.target.value)
                            }
                            placeholder="Введіть значення"
                            className="p-column-filter w-full"
                        />
                        <label>Назва товару</label>
                    </FloatLabel>
                </div>
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={tableFilters.division_name.value}
                            onChange={e => handleMobileFilterChange("division_name", e.value)}
                            options={ctx.enums.divisions.data}
                            placeholder="Виберіть значення"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Точка продажу</label>
                    </FloatLabel>
                </div>
                <div className="col-6 flex justify-content-center">
                    <Button severity="secondary" outlined style={{ width: "98%" }} onClick={() => clearMobileFilters()} label="Очистити фільтри" />
                </div>
                <div className="col-6 flex justify-content-center">
                    <Button severity="success" outlined style={{ width: "98%" }} onClick={() => filterApply()} label="Застосувати" />
                </div>
            </div>
        )
    }

    const nameBodyTemplate = (rowData) => {
        return (
            <div className="flex flex-column">
                <div>{rowData.product_name}</div>
                {rowData.note !== "" && <div className="text-sm font-italic" style={{ opacity: 0.8 }}>{rowData.note}</div>}
            </div>
        );
    };

    const quantityTemplate = (rowData) => {
        return (
            <div className="flex flex-row">
                <div>{formatQuantityWithMeasurement(rowData.total_quantity, rowData.measurement_units)} {"("}<i className="pi pi-lock"/>{rowData.booked}{")"}</div>
            </div>
        )
    }

    const priceTemplate = (rowData) => {

        const convertedPriceAmount = formatCurrency(rowData.sale_price, rowData.sale_price_currency);
        if(rowData.sale_price_currency === "UAH"){
            return convertedPriceAmount;
        }
        else{
            return <div className="flex flex-column">
                <div>{convertedPriceAmount}</div>
                <div className="text-sm" style={{ opacity: 0.8 }}>{`(${formatCurrency(convertSumWithLatestCurrencyRate(rowData.sale_price_currency, rowData.sale_price), "UAH")})`}</div>
            </div>;
        }
    }

    const newSaleButtonHandler = rowData => {
        if (rowData.identifier !== undefined) {
            createNewSale(rowData);
        }
        else {
            rowData.isNew = true;
            rowData.quantity = 1;
            setSaleItem(rowData);
            setVisible(true);
        }
    }

    const createNewSale = rowData => {
        const route = '/sales/newsale/';
        navigate(route, { state: { item: rowData } });
    }

    const actionBodyTemplate = rowData => {

        const buttons = [
            {
                label: 'Редагувати ціну',
                icon: 'pi pi-pencil',
                disabled: rowData.total_quantity === rowData.booked,
                command: () => { changePriceButtonHandler(rowData) }
            },
            {
                label: 'Історія закупок',
                icon: 'pi pi-shopping-bag',
                command: () => { getPurchases(rowData) }
            },

        ];

        if (!isMobile) {
            return (<>
                <Button
                    icon="pi pi-shopping-cart"
                    className={`p-button-rounded p-button-success ${rowData.total_quantity !== rowData.booked ? commonStyle.addButton : commonStyle.closeButton}`}
                    tooltip={rowData.total_quantity !== rowData.booked ? "Створити акт" : "Товари зарезервовані"}
                    tooltipOptions={{ showOnDisabled: true, position: "top" }}
                    disabled={rowData.total_quantity === rowData.booked}
                    onClick={() => newSaleButtonHandler(rowData)}
                />
                <Button
                    icon="pi pi-pencil"
                    className={`p-button-rounded p-button-info ${rowData.total_quantity !== rowData.booked ? commonStyle.editButton : commonStyle.closeButton}`}
                    tooltip={rowData.total_quantity !== rowData.booked ? "Редагувати ціну" : "Товари зарезервовані"}
                    tooltipOptions={{ showOnDisabled: true, position: "top" }}
                    disabled={rowData.total_quantity === rowData.booked}
                    onClick={() => changePriceButtonHandler(rowData)}
                />
                <Button
                    icon="pi pi-shopping-bag"
                    className={`p-button-rounded p-button-secondary ${commonStyle.closeButton}`}
                    tooltip="Історія закупок"
                    tooltipOptions={{ showOnDisabled: true, position: "top" }}
                    disabled={rowData.total_quantity === rowData.booked}
                    onClick={() => getPurchases(rowData)}
                />
                <Button
                    icon="pi pi-barcode"
                    className={`p-button-rounded p-button-warning ${commonStyle.warningTag}`}
                    tooltip="Друкувати цінники"
                    tooltipOptions={{ showOnDisabled: true, position: "top" }}
                    onClick={() => printPriceTag([rowData])}
                />
            </>)
        }
        else {
            return (<SplitButton
                label={null}
                icon="pi pi-shopping-cart"
                onClick={() => newSaleButtonHandler(rowData)}
                model={buttons}
                text
                ref={buttonRef}
            />)
        }
    }

    const productGroupFilterBase = () => {
        return (
            <div className={isDarkTheme ? "darkMode" : "lightMode"}>
                <Tree
                    value={productHierarcy}
                    selectionMode="single"
                    dragdropScope="demo"
                    onDragDrop={(e) => setProductHierarchy(e.value)}
                    onSelect={e => applyFilterFromMenu(e.node)}
                    className="w-full"
                    filter
                    filterMode="lenient"
                    filterPlaceholder="Пошук групи"
                />
            </div>)
    }

    const productGroupFilter = () => {
        if (isMobile) {
            return (
                <Sidebar visible={productGroupSidebarVisible} onHide={() => setProductGroupSidebarVisible(false)} className="w-full">
                    {productGroupFilterBase()}
                </Sidebar>
            )
        }
        else {
            return (<div className={`col-2 xlg:col-3 ${productCategoriesLoading ? "flex align-items-center justify-content-center" : ""}`} style={{ height: '100vh' }}>
                {productCategoriesLoading ? (<ProgressSpinner />) : (productGroupFilterBase())}
            </div>);
        }
    }

    const productGroupMenuClass = () => {
        if (isMobile) {
            return "col-12";
        }

        return "col-10 xlg:col-9";
    }

    const mobileTableBody = (rowData) => {
        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-12">
                        <div className="flex-column">
                            <div className='font-bold'>x{rowData.total_quantity} {rowData.product_name}</div>
                            {rowData.identifier && <div>{rowData.identifier}</div>}
                            <div>Зарезервовано: {rowData.booked} од.</div>
                            <div>Ціна: {formatCurrency(rowData.sale_price, rowData.sale_price_currency)}</div>
                            {rowData.sale_price_currency !== "UAH" && <div>у грн: {formatCurrency(convertSumWithLatestCurrencyRate(rowData.sale_price_currency, rowData.sale_price), "UAH")}</div>}
                            <div>Вартість закупки: {formatCurrency(rowData.last_income_price, rowData.last_income_currency)}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {actionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    return (<>
        <Toast ref={toast} />
        {isMobile && <Toolbar start={toolbarLeftTemplate} />}
        <div className="grid">
            {productGroupFilter()}
            <div className={productGroupMenuClass()}>
                {isMobile ? (
                    <DataTable value={leftovers} stripedRows dataKey="id" lazy header={mobileTableHeader} loading={loading} paginator onPage={onPage} first={lazyState.first} totalRecords={totalRecords} rows={lazyState.rows} rowsPerPageOptions={[10, 20, 50]}
                        paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown">
                        <Column field="product_name" headerStyle={{ display: 'none' }} body={mobileTableBody} />
                    </DataTable>
                ) : (
                    <DataTable value={leftovers} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} header={header}
                        first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]}
                        selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        onFilter={onFilter} filters={tableFilters}
                        emptyMessage="Товарів не знайдено" tableStyle={{ minWidth: '60rem' }} >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                        <Column field="product_name" header="Товар" sortable filter filterElement={InputTextTemplate} onFilterApplyClick={filterApply} onFilterClear={() => clearFilter("product_name", "")}
                            showFilterMatchModes={false} body={nameBodyTemplate} style={{ width: '20%' }}/>
                        <Column field="brand_name" header="Бренд" sortable filter filterElement={options => DropDownTemplate(options, ctx.enums.brands_dictionary.data)} onFilterApplyClick={filterApply} onFilterClear={() => clearFilter("brand_name", "")}
                            showFilterMatchModes={false}/>
                        <Column field="division_name" header="Точка продажу" filter filterElement={options => DropDownTemplate(options, ctx.enums.divisions.data)} onFilterApplyClick={filterApply} onFilterClear={() => clearFilter("division_name", "")}
                            showFilterMatchModes={false} />
                        <Column field="identifier" header="Ідентифікатор" />
                        <Column field="total_quantity" header="Кількість" body={quantityTemplate} sortable />
                        <Column field="last_income_price" header="Вартість останньої закупівлі" body={(rowData) => formatCurrency(rowData.last_income_price, rowData.last_income_currency)} />
                        <Column field="sale_price" header="Вартість продажу" body={priceTemplate} />
                        <Column field="action" style={{ width: '15%' }} body={actionBodyTemplate} />
                    </DataTable>)}
            </div>
            <Sidebar visible={visible} position="right" onHide={() => setVisible(false)} className={commonStyle.shortSideBar}>
                <form onSubmit={sideBarFormik.handleSubmit}>
                    <div className={commonStyle.sideBarInput}>
                        <div className="p-inputgroup flex-column">
                            <FloatLabel>
                                <InputText
                                    name="quantity"
                                    value={sideBarFormik.values.quantity}
                                    onChange={(e) => { sideBarFormik.setFieldValue('quantity', e.target.value) }}
                                    className={sideBarFormik.errors.quantity && sideBarFormik.touched.quantity ? 'p-invalid' : ''}
                                />
                                <label>Кількість</label>
                            </FloatLabel>
                            {sideBarFormik.errors.quantity && sideBarFormik.touched.quantity && (<small className={commonStyle.errorSmall}>{sideBarFormik.errors.quantity}</small>)}
                        </div>
                    </div>
                    <div>
                        <Button label="Створити акт" severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
                    </div>
                </form>
            </Sidebar>
            <Sidebar visible={changePriceSiderBarVisible} position="right" onHide={() => setChangePriceSiderBarVisible(false)} className={commonStyle.shortSideBar}>
                <form onSubmit={changePriceFormik.handleSubmit}>
                    <TextInput formik={changePriceFormik} paramName="product_name" label="Назва товару" isDisabled customStyle="w-full" />
                    <CheckboxInput formik={changePriceFormik} paramName="use_product_sale_price" label="Використовувати ціну продажу з довідника" />
                    {!changePriceFormik.values.use_product_sale_price && <>
                        <DropdownInput
                            formik={changePriceFormik}
                            paramName="custom_sale_price_currency"
                            onChange={(val) => changePriceFormik.setFieldValue("custom_sale_price_currency", val)}
                            context={systemCurrenciesDropdown}
                            label="Валюта продажу"
                            customStyle="w-full"
                        />
                        <NumberInput 
                            label="Ціна продажу в валюті розрахунку, за одиницю" 
                            value={changePriceFormik.values.custom_sale_price}
                            onChange={(val) => changePriceFormik.setFieldValue("custom_sale_price", val)}
                            errors={changePriceFormik.errors.custom_sale_price}
                            touched={changePriceFormik.touched.custom_sale_price}
                            customStyle="w-full"/>
                    </>}
                    <div>
                        <Button label="Змінити ціну" severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
                    </div>
                </form>
            </Sidebar>
            <Sidebar visible={purchasedSidebarVisible} position="right" onHide={() => setPurchasedSidebarVisible(false)} className={!isMobile ? commonStyle.sidebarTable : "w-full"}>
                <DataTable value={purchases}>
                    <Column field="act_number" header="Номер акту" />
                    <Column field="act_date" header="Дата акту" />
                    <Column field="quantity" header="Кількість" />
                    <Column field="price" header="Ціна" body={(rowData) => formatCurrency(rowData.price, rowData.currency)} />
                </DataTable>
            </Sidebar>
            <StickerPrintSidebar visible={stickerSideBarVisible} onHide={() => setStickerSidebarVisible(false)} data={selectedProducts} />
        </div>
    </>);
}

export default LeftOvers;